// extracted by mini-css-extract-plugin
export default {"floatingBlock":"styles_floatingBlock__m+nbY","checkout":"styles_checkout__NL7T2","checkoutItem":"styles_checkoutItem__OnWJX","button":"styles_button__7Ilh7"};